import React from 'react';
import ban3 from "../../assets/images/live/ban3.gif";

const Banner = () => {
    return (
        <div>
            <ul id="adv1"
                style={{margin: '0 auto', padding: '0', width: '520px', height: '80px', overflow: "hidden"}}>
                <li id="adv1_20989_1" style={{opacity: '1'}}>
                    <a href="/">
                        <img src={ban3} border="0" width="520" height="80" alt="" style={{borderRadius: "10px"}}/>
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default Banner;